import { CSSProperties, useEffect, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import { Toaster as HotToaster } from 'react-hot-toast'

import './Toaster.css'

export const defaultToasterZIndex = 22099
const toasterLayerId = 'campai-toast-layer'

const toastOptions = {
    className: 'toaster',
    error: { className: 'toaster toaster-error' },
    success: { className: 'toaster toaster-success' },
}

export const Toaster = ({ offsetTop, zIndex }: { offsetTop?: string; zIndex?: number }) => {
    const [container, setContainer] = useState<HTMLElement | null>(null)

    useEffect(() => {
        if (typeof document === 'undefined') {
            return
        }

        const existingContainer = document.getElementById(toasterLayerId)

        if (existingContainer instanceof HTMLElement) {
            existingContainer.style.position = 'relative'
            existingContainer.style.zIndex = String(zIndex ?? defaultToasterZIndex)
            setContainer(existingContainer)
            return
        }

        const nextContainer = document.createElement('div')
        nextContainer.id = toasterLayerId
        nextContainer.dataset.slot = 'toast-layer'
        nextContainer.style.position = 'relative'
        nextContainer.style.zIndex = String(zIndex ?? defaultToasterZIndex)
        document.body.appendChild(nextContainer)
        setContainer(nextContainer)
    }, [zIndex])

    const containerStyle = useMemo(() => {
        const result: CSSProperties = {
            zIndex: zIndex ?? defaultToasterZIndex,
        }

        if (offsetTop) {
            result.top = offsetTop
        }

        return result
    }, [offsetTop, zIndex])

    if (!container) {
        return null
    }

    return createPortal(
        <HotToaster position="top-center" toastOptions={toastOptions} containerStyle={containerStyle} />,
        container
    )
}
